<template>
  <div class="find-phone">
    <div v-if="findStatus === 'noSubmit'" class="form">
      <div class="tips">
        <p>1. 请确保与报名时填写的证件号码一致</p>
        <p>2. 证件号码包括身份证、护照</p>
      </div>
      <el-form ref="ruleForm" :model="formValues" :rules="rules" label-width="180px" center>
        <el-form-item label="选手证件类型" prop="identityType" label-width="110px">
          <el-select v-model="formValues.identityType" placeholder="请选择证件类型" @change="changeIdentifyType" clearable>
            <el-option v-for="op in cardIdOptions" :label="op.name" :value="op.id || op.name" :key="op.id || op.name">
              {{ op.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选手证件号码" prop="identityValue" label-width="110px">
          <el-input v-model.trim="formValues.identityValue" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="find-result" v-else-if="findStatus === 'success'">
      <p class="pixelate-phone">您的报名手机号为： {{ pixelatePhone }}</p>
      <p class="go-login" @click="goLogin">去登录 ></p>
    </div>
    <div class="find-result" v-else>
      <p class="find-fail">未查询到您的报名手机号。</p>
      <p class="find-fail">请确认您的报名证件号码，或点击【首页】前往NOC官网进行咨询。</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { FormItem, Form, Input, Select, Option } from 'element-ui'
import cardIdOptions from "./options/cardId-options";
import { validateCardId } from './check-items'
import {
  getSignPhoneNumber
} from '@/services/student';
export default {
  components: {
    ElFormItem: FormItem,
    ElForm: Form,
    ElInput: Input,
    ElOption: Option,
    ElSelect: Select
  },
  props: {
    formType: String,
    findStatus: String
  },
  data() {
    return {
      cardIdOptions,
      formValues: {
        identityType: '',
        identityValue: null
      },
      rules: {
        identityType: [
          {required: true, message: '请输入证件类型', trigger: 'change'}
        ],
        identityValue: [
          {required: true, message: '请输入证件号码', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              validateCardId(this.formValues.identityType, rule, value, callback)
            },
            trigger: 'blur'
          }
        ]
      },
      pixelatePhone: ''
    }
  },
  computed:{
    ...mapState({
      competitionId: state => state.router.id
    })
  },
  methods: {
    changeIdentifyType() {
      this.formValues.identityValue = ''
    },
    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if(!valid) return;
        try {
          // 接口请求成功
          const { status, data } = await getSignPhoneNumber({
            competitionId: this.competitionId,
            identityType: this.formValues.identityType,
            identityValue: this.formValues.identityValue
          })
          if(status === 200) {
            this.pixelatePhone = data;
            this.$emit('update:findStatus', 'success');
          }
        } catch(e) {
          const { status, message } = e.data
          if(status === 400) {
            this.$elMessage({
              message,
              type: 'error'
            });
          }
          this.$emit('update:findStatus', 'fail');
        }
      })
    },
    goLogin() {
      this.$emit('update:findStatus', 'noSubmit');
      this.$emit('update:formType', 'checkLogin');
    }
  }
}
</script>

<style scoped lang="less">
.find-phone {
  .form {
    display: flex;
    align-items: center;
    flex-direction: column;
    .tips {
      width: fit-content;
      font-size: 12px;
      margin-bottom: 20px;
      p {
        margin: 0;
        text-align: left;
      }
    }
  }
  .el-input, .el-select, .el-cascader {
    width: 300px;
  }
  .find-result {
    font-size: 14px;
    margin: 0 auto;
    width: fit-content;
    box-sizing: content-box;
    .pixelate-phone {
      text-align: center;
      padding: 0 50px;
    }
    .go-login {
      text-align: right;
      color: #409eff;
      margin-top: 30px;
      cursor: pointer;
      padding-left: 30px;
    }
    .find-fail {
      text-align: left;
    }
  }
} 
</style>
